export default "__VITE_ASSET__Cy8SPp7n__"